/* ========================================================= * Material Kit 2 PRO React - v2.0.0 ========================================================= * Product Page: https://www.creative-tim.com/product/material-kit-pro-react * Copyright 2021 Creative Tim (https://www.creative-tim.com) Coded by www.creative-tim.com ========================================================= * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. */


// react
import { useMaterialUIController } from "/context";

// next
import dynamic from "next/dynamic";

// Config
import config from "/config";

// MUI Icons
const Facebook = dynamic(() => import('@mui/icons-material/Facebook'), { loading: () => null });
const Twitter = dynamic(() => import('@mui/icons-material/Twitter'), { loading: () => null });
const YouTube = dynamic(() => import('@mui/icons-material/YouTube'), { loading: () => null });
const Instagram = dynamic(() => import('@mui/icons-material/Instagram'), { loading: () => null });
const Language = dynamic(() => import('@mui/icons-material/Language'), { loading: () => null });

// PRO
const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });
const MDButton = dynamic(() => import('/components/MDButton'), { loading: () => null });
const MDTypography = dynamic(() => import('/components/MDTypography'), { loading: () => null });

function FindUsOn() {
  const [controller] = useMaterialUIController();
  return (
    <>
      <MDTypography variant="h6" component="p" color="white" mt={controller.mobileView ? 4 : 8} mb={0}>
        See our custom work on
      </MDTypography>
      <MDBox display="flex" justifyContent="center" sx={{ alignItems: "center" }}>
        <MDButton
          href={config.FbURL}
          target="_blank"
          rel="noreferrer noopener"
          variant="text"
          mr={3}
          iconOnly
          circular
          size="large"
          sx={{ fontSize: 20 }}
          aria-label="Autumn Leaf's Facebook Profile" 
        >
          <Facebook color="white" size="large" />
        </MDButton>
        <MDButton
          href={config.InstagramURL}
          target="_blank"
          rel="noreferrer noopener"
          variant="text"
          mr={3}
          iconOnly
          circular
          size="large"
          sx={{ fontSize: 20 }}
          aria-label="Autumn Leaf's Instagram Profile"
        >
          <Instagram color="white" size="large" />
        </MDButton>
        <MDButton
          href={config.YoutubeURL}
          target="_blank"
          rel="noreferrer noopener"
          variant="text"
          mr={3}
          iconOnly
          circular
          size="large"
          sx={{ fontSize: 20 }}
          aria-label="Autumn Leaf's YouTube Profile"
        >
          <YouTube color="white" size="large" />
        </MDButton>
        <MDButton
          href={config.TwitterURL}
          target="_blank"
          rel="noreferrer noopener"
          variant="text"
          mr={3}
          iconOnly
          circular
          size="large"
          sx={{ fontSize: 20 }}
          aria-label="Autumn Leaf's Twitter Profile"
        >
          <Twitter color="white" size="large" />
        </MDButton>
        <MDButton
          href={config.frontURL}
          target="_blank"
          rel="noreferrer noopener"
          variant="text"
          mr={3}
          iconOnly
          circular
          size="large"
          sx={{ fontSize: 20 }}
          aria-label="Autumn Leaf Website"
        >
          <Language color="white" size="large" />
        </MDButton>
      </MDBox>
    </>
  );
}

export default FindUsOn;
